import React, { useState } from 'react';
import './App.css';
import { SunIcon, MoonIcon } from './components/ThemeIcons';

function App() {
  const [isLightTheme, setIsLightTheme] = useState(() => {
    if (typeof window === 'undefined') {
      return true;
    }
    const stored = window.localStorage.getItem('bahn-home-theme');
    return stored === null ? true : stored === 'light';
  });

  const handleThemeToggle = () => {
    setIsLightTheme((prev) => {
      const nextIsLight = !prev;
      window.localStorage.setItem('bahn-home-theme', nextIsLight ? 'light' : 'dark');
      return nextIsLight;
    });
  };

  return (
    <div className={`App bahn-shell ${isLightTheme ? 'bahn-shell--light' : ''}`}>
      <header className="App-header">
        <img src="/circle_logo.png" alt="Bahn Logo" className="logo" />
        <button
          type="button"
          className="bahn-shell__theme-toggle"
          onClick={handleThemeToggle}
          aria-label={isLightTheme ? 'Switch to dark mode' : 'Switch to light mode'}
          title={isLightTheme ? 'Switch to dark mode' : 'Switch to light mode'}
        >
          {isLightTheme ? <MoonIcon /> : <SunIcon />}
        </button>
      </header>
      <main className="App-main">
        <section className="left-section">
          <h1 className="main-text">
            Bahn Labs
          </h1>
          <p>
            Bahn Labs provides software development services, <br/>focusing on product & R&D projects requiring expertise in <br/>Rust, Android and Blockchain-related technologies.
          </p>
        </section>
        <section className="right-section">
          <div className="right-section-content">
            <div className="project-group">
              <h2>Our Own Projects</h2>
              <a href="https://speedhare.io" target="_blank" rel="noopener noreferrer">
                speedhare.io
              </a>
            </div>
            <div className="project-group">
              <h2>Our Customer Projects</h2>
              <a href="https://eld.network" target="_blank" rel="noopener noreferrer">
                eld.network
              </a>
            </div>
          </div>
        </section>
      </main>
      <footer className="App-footer">
        <div className="footer-content">
          <div>© 2026 Bahn Labs Ltd | Contact Us:</div>
          <a
            href="https://www.linkedin.com/company/bahn-labs"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-linkedin"
            aria-label="Bahn Labs on LinkedIn"
          >
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
